import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReportsDropdownStyle } from "./ReportsDropdown.styled";
import ROUTE from "../../common/Routes";

const ReportsDropdown = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setShowDropdown((prev) => !prev);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  return (
    <ReportsDropdownStyle>
      <div ref={dropdownRef} className="reports-dropdown-wrapper">
        <button
          className="reports-dropdown-button"
          type="button"
          onClick={toggleDropdown}
          aria-expanded={showDropdown}
        >
          Reports{" "}
          <i className="bi bi-caret-down-fill" />
        </button>

        {showDropdown && (
          <div className="reports-dropdown-menu">
            <div
              className="reports-dropdown-item"
              onClick={() => {
                setShowDropdown(false);
                navigate(ROUTE.DownloadSummaryReport);
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              Summary
            </div>
            <div
              className="reports-dropdown-item"
              onClick={() => {
                setShowDropdown(false);
                navigate(ROUTE.DownloadSponsorsAccountsListsReport);
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              Sponsors Account Lists
            </div>
          </div>
        )}
      </div>
    </ReportsDropdownStyle>
  );
};

export default ReportsDropdown;
